/* ==========================================================================
   MEGA MENU HEADER — dtfgears
   No dependencies. Safe to load with defer.
   Re-initialises on Shopify theme-editor section reloads.
   ========================================================================== */
(function () {
  'use strict';

  var OPEN_DELAY = 90;   // ms — stops panels flashing while sweeping the nav
  var CLOSE_DELAY = 180; // ms — forgiving diagonal travel into the panel

  function initHeader(header) {
    if (!header || header.dataset.mmReady === 'true') return;
    header.dataset.mmReady = 'true';

    var items = Array.prototype.slice.call(header.querySelectorAll('[data-mm-item]'));
    var openTimer, closeTimer, current = null;

    function open(item) {
      clearTimeout(closeTimer);
      if (current && current !== item) close(current);
      item.classList.add('is-open');
      var t = item.querySelector('.mm-nav__trigger');
      if (t) t.setAttribute('aria-expanded', 'true');
      current = item;
    }

    function close(item) {
      if (!item) return;
      item.classList.remove('is-open');
      var t = item.querySelector('.mm-nav__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (current === item) current = null;
    }

    function closeAll() { items.forEach(close); }

    items.forEach(function (item) {
      var trigger = item.querySelector('.mm-nav__trigger');

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { open(item); }, OPEN_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { close(item); }, CLOSE_DELAY);
      });

      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          item.classList.contains('is-open') ? close(item) : open(item);
        });

        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            open(item);
            var first = item.querySelector('.mm-rail__btn, .mm-group__list a');
            if (first) first.focus();
          }
        });
      }

      // keep the panel open while tabbing through it
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });

      // brand rail → pane switching
      var rails = Array.prototype.slice.call(item.querySelectorAll('.mm-rail__item'));
      var panes = Array.prototype.slice.call(item.querySelectorAll('.mm-pane'));

      rails.forEach(function (li) {
        var btn = li.querySelector('.mm-rail__btn');
        if (!btn) return;

        function activate() {
          var key = li.getAttribute('data-mm-brand');
          rails.forEach(function (x) { x.classList.toggle('is-active', x === li); });
          panes.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-mm-pane') === key);
          });
        }

        btn.addEventListener('mouseenter', activate);
        btn.addEventListener('focus', activate);
        // first tap on touch only switches the pane, second tap follows the link
        btn.addEventListener('click', function (e) {
          if (window.matchMedia('(hover: none)').matches && !li.classList.contains('is-active')) {
            e.preventDefault();
            activate();
          }
        });
      });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mm-item]')) closeAll();
    });

    buildDrawer(header);
  }

  /* ---------------- mobile drawer, generated from the desktop nav ---------------- */
  function buildDrawer(header) {
    var body = document.querySelector('[data-mm-drawer-body]');
    var drawer = document.querySelector('[data-mm-drawer]');
    var scrim = document.querySelector('[data-mm-scrim]');
    var burger = header.querySelector('[data-mm-burger]');
    var closeBtn = document.querySelector('[data-mm-close]');
    if (!body || !drawer) return;

    body.innerHTML = '';
    var caret = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="m5 9 7 7 7-7"/></svg>';

    header.querySelectorAll('.mm-nav__item').forEach(function (item) {
      var trigger = item.querySelector('.mm-nav__trigger');
      var panel = item.querySelector('.mm-panel');
      if (!trigger) return;
      var label = trigger.textContent.trim();

      if (!panel) {
        var a = document.createElement('a');
        a.className = 'mm-row';
        a.href = trigger.getAttribute('href') || '#';
        a.textContent = label;
        body.appendChild(a);
        return;
      }

      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'mm-row';
      row.setAttribute('aria-expanded', 'false');
      row.innerHTML = '<span>' + label + '</span>' + caret;

      var sub = document.createElement('div');
      sub.className = 'mm-sub';

      var rails = panel.querySelectorAll('.mm-rail__item');

      if (rails.length) {
        rails.forEach(function (li) {
          var nameEl = li.querySelector('.mm-rail__name');
          var key = li.getAttribute('data-mm-brand');
          var pane = panel.querySelector('[data-mm-pane="' + key + '"]');
          if (!pane) return;

          var brow = document.createElement('button');
          brow.type = 'button';
          brow.className = 'mm-row';
          brow.setAttribute('aria-expanded', 'false');
          brow.innerHTML = '<span>' + (nameEl ? nameEl.textContent : '') + '</span>' + caret;

          var ul = document.createElement('ul');
          ul.className = 'mm-links';
          pane.querySelectorAll('.mm-group__list a').forEach(function (a) {
            var li2 = document.createElement('li');
            li2.appendChild(a.cloneNode(true));
            ul.appendChild(li2);
          });

          brow.addEventListener('click', function () {
            var isOpen = ul.classList.toggle('is-open');
            brow.setAttribute('aria-expanded', String(isOpen));
          });

          sub.appendChild(brow);
          sub.appendChild(ul);
        });
      } else {
        var ul2 = document.createElement('ul');
        ul2.className = 'mm-links is-open';
        panel.querySelectorAll('.mm-group').forEach(function (g) {
          var title = g.querySelector('.mm-group__title');
          if (title) {
            var head = document.createElement('li');
            head.innerHTML = '<a href="' +
              (title.querySelector('a') ? title.querySelector('a').getAttribute('href') : '#') +
              '"><strong>' + title.textContent.trim() + '</strong></a>';
            ul2.appendChild(head);
          }
          g.querySelectorAll('.mm-group__list a').forEach(function (a) {
            var li3 = document.createElement('li');
            li3.appendChild(a.cloneNode(true));
            ul2.appendChild(li3);
          });
        });
        sub.appendChild(ul2);
      }

      row.addEventListener('click', function () {
        var isOpen = sub.classList.toggle('is-open');
        row.setAttribute('aria-expanded', String(isOpen));
      });

      body.appendChild(row);
      body.appendChild(sub);
    });

    function setDrawer(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      if (scrim) scrim.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (burger) burger.setAttribute('aria-expanded', String(open));
      if (open) {
        var f = drawer.querySelector('.mm-row');
        if (f) f.focus();
      } else if (burger) {
        burger.focus();
      }
    }

    if (burger) burger.addEventListener('click', function () { setDrawer(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
    if (scrim) scrim.addEventListener('click', function () { setDrawer(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setDrawer(false);
    });
  }

  function boot() {
    document.querySelectorAll('[data-mega-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var h = e.target.querySelector('[data-mega-header]');
    if (h) { h.dataset.mmReady = 'false'; initHeader(h); }
  });
})();
